import { sendSeatRequest } from '../../_core/common/api/seatsApi';
import * as tracker from '../../_core/common/eventTracking/tracker';
import wrapWithErrorMonitoring from '../../_core/common/reliability/wrapWithErrorMonitoring';
import { getProductInventoryRpc } from '../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc';
import { rpcClient } from '../../rpcClient';
import { fetchAvailableSeats } from '../../_core/common/api/fetchAvailableSeats';
import { getOwnedProductsThatRequireCoreSeat } from '../../_core/utils/getOwnedHubs';
import { getSeatSelectOptions } from '../../_core/utils/getSeatSelectOptions';
import { getOwnedHubsAndSuiteApiNamesFromInventory } from '../../_core/utils/getOwnedHubsAndSuiteApiNamesFromInventory';
import { logRavenException } from '../../_core/utils/errors';
const getProductInventory = () => {
  return rpcClient.call(getProductInventoryRpc, {}).then(response => response.products);
};
export const fetchAvailableSeatOptionsAndOwnedProducts = () => {
  return Promise.all([fetchAvailableSeats(), getProductInventory()]).then(([seats, products]) => {
    const ownedProductsThatRequireCoreSeat = getOwnedProductsThatRequireCoreSeat(products);
    const ownedHubsAndSuiteApiNames = getOwnedHubsAndSuiteApiNamesFromInventory(products);
    const seatOptions = getSeatSelectOptions(seats, ownedProductsThatRequireCoreSeat);
    return {
      seatOptions,
      ownedHubsAndSuiteApiNames
    };
  }).catch(availableSeatsAndProductsError => {
    console.error(['Error resolving seats data promise', availableSeatsAndProductsError]);
    return {
      seatOptions: [],
      ownedHubsAndSuiteApiNames: []
    };
  });
};
export const requestSeatUpgrade = wrapWithErrorMonitoring('requestSeatUpgrade', ({
  apiName,
  isLegacySeatsModel,
  requestReason,
  requestedSeatType
}) => {
  return sendSeatRequest({
    apiName,
    isLegacySeatsModel,
    requestReason,
    requestedSeatType
  }).then(() => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request seat succeeded',
      apiName,
      requestReason,
      requestedSeat: requestedSeatType
    });
  }).catch(error => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request seat failed',
      apiName,
      requestReason,
      requestedSeat: requestedSeatType
    });
    logRavenException({
      customMessage: 'Error requesting seat upgrade',
      error,
      fingerprint: ['requestSeatUpgrade']
    });
    throw error;
  });
});